/*eslint-disable */
var $ = window.jQuery = require('jquery')

import { bus } from '@/main';
import carousel from 'vue-owl-carousel';

export default {
  name: 'vista-public-media-list',
  components: {
    carousel
  },
  props: [],
  data () {
    return {
      ourEventData:null,
      ourEventResults:[]
    }
  },
  computed: {
  },
  mounted () {
    this.$store.dispatch('eventListAction').then((res) => {
      this.ourEventData = res.data
      this.ourEventResults = this.ourEventData.data
    })
  },
  methods: {
  },
  watch:{
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
  },
  beforeRouteLeave: function(to, from, next) {
    $('body').removeClass('dashboard')
    next();
  },
}